import type { TrayModel } from '../tray/TrayModel';
import type { BoardModel } from '../board/BoardModel';
import type { TileColor } from '../../TileColor';
import { removeRandomElement } from '../../../../utils/array-utils';
import { TileRemovalReason } from '../board/BoardEvents';

export class ReviveAction {
  constructor(
    private readonly tray: TrayModel,
    private readonly board: BoardModel,
  ) {}

  public async execute(clearCount: number): Promise<void> {
    if (!this.tray.hasActiveTiles()) this.tray.refillItems(false);

    const scheduler = this.board.getScheduler();
    await scheduler.wait(null, 500);

    this.clearRandomStacks(clearCount, this.tray.getTopColors());
  }

  private clearRandomStacks(clearCount: number, colors: TileColor[], nextStackDelay = 250): void {
    const nonEmptyStacks = this.board.getStacks().filter((stack) => stack.hasTiles() && !stack.blocker);
    const stacks = nonEmptyStacks.filter((stack) => stack.isConnectedToColors(colors));

    while (stacks.length < clearCount && nonEmptyStacks.length > 0) {
      stacks.push(removeRandomElement(nonEmptyStacks));
    }

    let stacksBeingCleared = 0;
    while (stacks.length > 0 && stacksBeingCleared < clearCount) {
      const stack = removeRandomElement(stacks);
      const delay = stacksBeingCleared * nextStackDelay;
      stacksBeingCleared += 1;
      stack.locked = true;

      this.board
        .getScheduler()
        .wait(null, delay)
        .then(
          () => {
            this.board.removeTilesFromStack({
              stack,
              reason: TileRemovalReason.Revive,
              tilesAmount: stack.getTileCount(),
            });
          },
          () => {},
        );
    }
  }
}
